/**
 * Claims App version, used for onboarding tour gating.
 * Increment this when a new feature tour is added.
 * The tour system compares this against profile.claims_last_seen_app_version.
 */
export const CLAIMS_APP_VERSION = '2.5.0';
